<mat-icon
  [svgIcon]="iconName"
  [style.height]="height"
  [style.width]="width"
  [style.maxHeight]="maxHeight"
  [style.maxWidth]="maxWidth"
  [ngClass]="['svg-color-' + fillSvgColor, 'path-color-' + fillPathColor]"
></mat-icon>
